const API = process.env.REACT_APP_BACKEND_URL;
const OLD_HOST = 'www.trxl-performance.de';

/**
 * Convert external product image URLs to use the CDN proxy.
 * Local/uploaded images are returned as-is.
 */
export function cdnImage(url) {
  // v312a-fix-18 typeguard: accept non-strings safely
  if (!url || typeof url !== 'string') return '/images/placeholder.svg';
  // Already proxied or local
  if (url.startsWith('/') || url.includes('/api/cdn/')) return url;
  // External URL from old shop -> proxy through CDN
  if (url.includes(OLD_HOST)) {
    return `${API}/api/cdn/img?url=${encodeURIComponent(url)}`;
  }
  return url;
}
